import React, { Component } from 'react'

import ContentInfo from '../_ContentInfo'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import { FormGroup, Textarea, Select, Text } from '../../../../../v2SPRINTA/atoms/Form'
// import Switch from '../../../../../v2SPRINTA/atoms/Form/Switch'
import { Col, Row } from '../../../../../v2SPRINTA/atoms/Grid'
import CoverContent from '../../CoverContent'
// import RadioBox from '../../../../../SPRINTA/molecules/RadioBox'

import { saveExperienceprofile } from '../../_utils'

class BioProfile extends Component {
    inputRefs = {}

    handleChange(target, index) {
        let profile = this.props.data.profile

        let v = target.type === 'checkbox' ? target.checked : target.value
        
        if(index || index === 0) {
            let d = profile[target.name] || []
            d[index] = v
            v = d
        }

        profile[target.name] = v

        this.props.setData({
            profile
        }, () => {
            if(['radio', 'select-one', 'checkbox'].indexOf(target.type) > -1)
            this.handleChanged(target)
        })
    }
    
    handleChanged(target) {
        this.validAndSaveField(target)
    }

    validAndSaveField(target) {
        const { name } = target

        if(this.hasFieldError[name] && this.hasFieldError[name]()) return;

        const form = {}
        // if(name === 'graduation') {
        //     form[name] = this.props.data.profile[name] ?  1 : 0
        // } else
        if(name === 'links') {
            this.props.data.profile[name].forEach((v, k) => {
                form[`links[${k}]`] = v
            })
        } else
        form[name] = this.props.data.profile[name]

        let async = saveExperienceprofile(this.props.token, form)
        .then(resp => {
        })

        if(this.props.async) this.props.async(async)
    }

    hasFieldError = {
        bio: () => {
            if(!this.props.data.profile.bio) {
                let error = "Informe a história"
                this.bio.setError(error)
                return {
                    element: this.bio.refs.textarea,
                    error
                }
            }
            return false
        },
        phone: () => {
            if(!this.props.data.profile.phone || this.props.data.profile.phone.length < 11) {
                let error = "Informe o telefone"
                this.phone.setError(error)
                return {
                    element: this.phone.refs.input,
                    error
                }
            }
            return false
        },
        placeTime: () => {
            if(!this.props.data.profile.placeTime) {
                let error = "Informe a quanto tempo sua academia funciona"
                this.placeTime.setError(error)
                return {
                    element: this.placeTime.refs.select,
                    error
                }
            }
            return false
        },
        // expTime: () => {
        //     if(!this.props.data.profile.expTime) {
        //         let error = "Informe quanto tempo você tem de experiência"
        //         this.expTime.setError(error)
        //         return {
        //             element: this.expTime.refs.select,
        //             error
        //         }
        //     }
        //     return false
        // },
        // graduation: () => {
        //     if(!this.props.data.profile.graduation) {
        //         let error = "Informe sobre sua graduação"
        //         return {
        //             element: this.graduation.refs.div,
        //             error
        //         }
        //     }
        //     return false
        // },
        links: () => {
            if(!this.props.data.profile.links || this.props.data.profile.links.length < 1) {
                let error = "Informe ao menos uma rede social da sua academia"
                return {
                    element: this.links.refs.div,
                    error
                }
            }
            return false
        },
    }


    validate() {
        let errors = []

        Object.keys(this.hasFieldError).forEach(item => {
            let error = this.hasFieldError[item]();
            if(error)
            errors.push(error)
        })

        return errors
    }

    inStep() {
        let { bio, placeTime, expTime, graduation, links } = this.props.data.profile
        return bio || placeTime || expTime || graduation || (links && links.length > 0) ? true  : false
    }

    render() {
        return (
            <div>
                <CoverContent minHeight='350px' image={require('./cover-profile.jpg')}>
                    <Display heading size={2}>ANTES DE FINALIZAR, FALE SOBRE SUA ACADEMIA</Display>
                </CoverContent>

                <ContentInfo
                    title='Fale sobre a sua academia'
                    description='Fale mais sobre sua academia, toda a história. Quanto mais detalhes soubermos da sua academia, mais poderemos lhe ajudar.'
                    steps={this.props.steps}
                    >

                    <Row>
                        <Col size='12'>
                            <FormGroup>
                                <Display size={3}>
                                    Descreva sua academia para os visitantes
                                </Display>
                            </FormGroup>
                        </Col>

                        <Col size='12'>
                            <FormGroup>
                                <Textarea
                                    label='Qual a história da sua academia?'
                                    name="bio"
                                    ref={ref => this.bio = ref}
                                    value={this.props.data.profile.bio || ''}
                                    onChangeDOM={e => this.handleChanged(e.target)}
                                    onChange={e => this.handleChange(e.target)}
                                    />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>

                        <Col size='12'>
                            <FormGroup>
                                <Display size={3}>
                                    Há quanto tempo existe a sua academia
                                </Display>
                            </FormGroup>
                        </Col>

                        <Col size='12 12 6'>
                            <FormGroup>
                                <Select
                                    label='Há quanto tempo sua academia foi criada?'
                                    name="placeTime"
                                    value={this.props.data.profile.placeTime || ''}
                                    onChange={e => this.handleChange(e.target)}
                                    ref={ref => this.placeTime = ref}
                                >
                                    <option>Selecione</option>
                                    <option>Menos de um ano</option>
                                    <option>De um a três anos</option>
                                    <option>Mais de 3 anos</option>
                                </Select>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col size='12'>
                            <FormGroup>
                                <Display size={3}>
                                Por fim, nos informe as redes sociais da sua academia
                                </Display>
                                <br />
                                Queremos ver como ela é nas redes sociais e possivelmente contatá-lo, caso seja necessário.
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col size='12'>
                            <FormGroup>
                                <Text
                                    label='Informe o número do telefone com ddd'
                                    name="phone"
                                    mask='###############'
                                    ref={ref => this.phone = ref}
                                    value={this.props.data.profile.phone && this.props.data.profile.phone ? this.props.data.profile.phone : ''}
                                    onChangeDOM={e => this.handleChanged(e.target)}
                                    onChange={e => this.handleChange(e.target)}
                                />
                            </FormGroup>
                        </Col>
                        <Col size='12'>
                            <FormGroup ref={ref => this.links = ref}>
                                <Text
                                    label='Como encontramos no Instagram'
                                    name="links"
                                    value={this.props.data.profile.links && this.props.data.profile.links[0] ? this.props.data.profile.links[0] : ''}
                                    onChangeDOM={e => this.handleChanged(e.target, 0)}
                                    onChange={e => this.handleChange(e.target, 0)}
                                />
                            </FormGroup>
                        </Col>
                        <Col size='12'>
                            <FormGroup>
                                <Text
                                    label='Como encontramos no Facebook'
                                    name="links"
                                    value={this.props.data.profile.links && this.props.data.profile.links[1] ? this.props.data.profile.links[1] : ''}
                                    onChangeDOM={e => this.handleChanged(e.target, 1)}
                                    onChange={e => this.handleChange(e.target, 1)}
                                />
                            </FormGroup>
                        </Col>
                        {/* <Col size='12'>
                            <FormGroup>
                                <Text
                                    label='Digite o endereço do seu perfil no Linkedin'
                                    name="links"
                                    value={this.props.data.profile.links && this.props.data.profile.links[2] ? this.props.data.profile.links[2] : ''}
                                    onChangeDOM={e => this.handleChanged(e.target, 2)}
                                    onChange={e => this.handleChange(e.target, 2)}
                                />
                            </FormGroup>
                        </Col> */}
                        
                    </Row>

                </ContentInfo>
            </div>
        )
    }

}

export default BioProfile


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/Steps/BioProfile/index.js